/* 肉牛良繁平台接口 */

import request from './axiosFun'; // 有 loading
import apiHttp from './apiHttp'; // 无 loading

var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}

/* 用户基础信息接口 */
export function getBreedUserInfo_Beef(data) {
  return apiHttp({
    url: url + '/breedsystem/breedUser/getBreedUserInfo',
    method: 'post',
    data
  });
}

/* 用户角色统计 */
export function getAreaRoleCount_Beef(data) {
  return apiHttp({
    url: url + '/breedsystem/breedUser/getAreaRoleCount',
    method: 'post',
    data
  });
}

/* 人员管理接口 */
export function getAreaSeedUsers_Beef(data) {
  return request({
    url: url + '/breedsystem/breedUser/getAreaBreedUsers',
    method: 'post',
    data
  });
}

/* 新增人员 */
export function saveBreedUserInfo_Beef(data) {
  return request({
    url: url + '/breedsystem/breedUser/saveBreedUserInfo',
    method: 'post',
    data
  });
}

/* 修改人员 */
export function updateBreedUserInfo_Beef(data) {
  return request({
    url: url + '/breedsystem/breedUser/updateBreedUserInfo',
    method: 'post',
    data
  });
}

/* 角色列表 */
export function getAppRoleList_Beef(data) {
  return request({
    url: url + '/breedsystem/breedUser/getAppRoleList',
    method: 'post',
    data
  });
}

/* 机构列表 */
export function queryInstitutionList_Beef(data) {
  return request({
    url: url + '/breedsystem/institutionInfo/queryInstitutionList',
    method: 'post',
    data
  });
}

/* 区域列表 */
export function getAreaInfoByCode_Beef(data) {
  return request({
    url: url + '/breedsystem/breedUser/getAreaInfoByCode',
    method: 'post',
    data
  });
}
/* 区域列表下级查询*/
export function getNationalInfoByProps_Beef(data) {
  return request({
    url: url + '/base-server/userCore/getNationalInfoByProps',
    method: 'post',
    data
  });
}

/* 重置密码 */
export function resetPassword_Beef(data) {
  return request({
    // url: url + '/breedsystem/breedUser/resetPassword', // 旧的
    url: url + '/base-server/userCore/resetPassword',
    method: 'post',
    data
  });
}

/* 删除 */
export function rdeleteBreedUser_Beef(data) {
  return request({
    url: url + '/breedsystem/breedUser/deleteBreedUser',
    method: 'post',
    data
  });
}

/* 机构管理列表 */
export function pageQueryInstitution_Beef(data) {
  return request({
    url: url + '/breedsystem/institutionInfo/pageQueryInstitution',
    method: 'post',
    data
  });
}

/* 查询机构管理员 */
export function queryInstitutionUsers_Beef(data) {
  return request({
    url: url + '/breedsystem/institutionInfo/queryInstitutionUsers',
    method: 'post',
    data
  });
}

/* 新增机构 */
export function saveInstitution_Beef(data) {
  return request({
    url: url + '/breedsystem/institutionInfo/saveInstitution',
    method: 'post',
    data
  });
}

/* 修改机构 */
export function updateInstitution_Beef(data) {
  return request({
    url: url + '/breedsystem/institutionInfo/updateInstitution',
    method: 'post',
    data
  });
}

/* 删除机构 */
export function deleteInstitution_Beef(data) {
  return request({
    url: url + '/breedsystem/institutionInfo/deleteInstitution',
    method: 'post',
    data
  });
}

/* 角色管理 */
export function getAppRoleListJS_Beef(data) {
  return request({
    // url: url + '/base-server/loginCore/getAppRoleList',
    url: url + '/breedsystem/breedUser/getAppRoleList',
    method: 'post',
    data
  });
}

/* 菜单管理 */
export function getAppMenuListCD_Beef(data) {
  return request({
    url: url + '/base-server/loginCore/getAppMenuList',
    method: 'post',
    data
  });
}

/* 冻精信息分页列表 */
export function pageBsSemenInfoDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/pageBsSemenInfo',
    method: 'post',
    data
  });
}

/* 编辑冻精 */
export function updateBsSemenInfoDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/updateBsSemenInfo',
    method: 'post',
    data
  });
}

/* 新增冻精 */
export function semenStorageDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/semenStorage',
    method: 'post',
    data
  });
}

/* 删除冻精 */
export function deleteBsSemenInfoDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/deleteBsSemenInfo',
    method: 'post',
    data
  });
}

/* 冻精等级数据统计 */
export function countForSemenInfoItemBySemenClassDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/countForSemenInfoItemBySemenClass',
    method: 'post',
    data
  });
}

/* 入库冻精库存 */
export function semenSaveStorageDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/semenSaveStorage',
    method: 'post',
    data
  });
}

/* 下发 - 领取人集合 */
export function getBreedUserListDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/breedUser/getBreedUserList',
    method: 'post',
    data
  });
}

/* 冻精下发 */
export function semenIssuedtDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/semenIssued',
    method: 'post',
    data
  });
}

/* 待领取集合 */
export function semenAwaitSendDrawPageDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/semenAwaitSendDrawPage',
    method: 'post',
    data
  });
}

/* 冻精领取 */
export function semenSendDrawDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/semenSendDraw',
    method: 'post',
    data
  });
}

/* 冻精报损 */
export function semenBreakage_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/semenBreakage',
    method: 'post',
    data
  });
}

/* 分页查询配种日志记录 */
export function pageBsLivestockBreedDJ_Beef(data) {
  return request({
    url: url + '/breedsystem/bsLivestockBreed/pageBsLivestockBreed',
    method: 'post',
    data
  });
}

/* 删除配种记录 */
export function deleteBreedInfo_Beef(data) {
  return request({
    url: url + '/breedsystem/bsLivestockBreed/deleteBreedInfo',
    method: 'post',
    data
  });
}



/* 导出配种日志记录 */
export function exportBsLivestockBreed_Beef(data) {
  return request({
    url: url + '/breedsystem/bsLivestockBreed/exportBsLivestockBreed',
    method: 'post',
    data
  });
}

/* 在栏畜只列表 */
export function findPcLivestockList_Beef(data) {
  return request({
    url: url + '/breedsystem/livestockInfo/findPcLivestockList',
    method: 'post',
    data
  });
}
/* 出栏畜只列表 */
export function findPcLivestockSaleList_Beef(data) {
  return request({
    url: url + '/breedsystem/livestockInfo/findPcLivestockSaleList',
    method: 'post',
    data
  });
}
/* 淘汰畜只列表 */
export function findPcLivestockOutList_Beef(data) {
  return request({
    url: url + '/breedsystem/livestockOut/findPcLivestockOutList',
    method: 'post',
    data
  });
}

/* 大屏 - 冻精使用量统计 */
export function countFrozenSpermUse_Beef(data) {
  return request({
    url: url + '/breedsystem/largeScreen/countFrozenSpermUse',
    method: 'post',
    data
  });
}

/* 大屏 - 配种工作统计 */
export function countBreedingJobs_Beef(data) {
  return request({
    url: url + '/breedsystem/largeScreen/countBreedingJobs',
    method: 'post',
    data
  });
}

/* 大屏 - 配种畜只统计 */
export function countBreedingAnimals_Beef(data) {
  return request({
    url: url + '/breedsystem/largeScreen/countBreedingAnimals',
    method: 'post',
    data
  });
}

/* 大屏 - 冻精数量统计 */
export function countFrozenSperm_Beef(data) {
  return request({
    url: url + '/breedsystem/largeScreen/countFrozenSperm',
    method: 'post',
    data
  });
}

/* 冻精下发牧场统计 */
export function countFrozenSpermDisbursementFarm_Beef(data) {
  return request({
    url: url + '/breedsystem/largeScreen/countFrozenSpermDisbursementFarm',
    method: 'post',
    data
  });
}

/* 主体管理数据 */
export function getBsUserFarmInfoPage_Beef(data) {
  return request({
    url: url + '/breedsystem/bs/farm/getFarmInfoPage',
    method: 'post',
    data
  });
}
// http://192.168.0.19:60000/breedsystem/bs/farm/getFarmInfoPage

/* 出入库管理列表 */
export function PcSemenSendRecordLogPage_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/PcSemenSendRecordLogPage',
    method: 'post',
    data
  });
}

/* 出入库管理列表 - 领取 - 返还 */
export function semenSendGoBack_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/semenSendGoBack',
    method: 'post',
    data
  });
}

/* 出入库管理列表 - 下发 - 撤回 */
export function semenIssuedWithdraw_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/semenIssuedWithdraw',
    method: 'post',
    data
  });
}

/* 出入库管理列表 - 下发 - 更改领取人 */
export function updSemenIssued_Beef(data) {
  return request({
    url: url + '/breedsystem/bsSemenInfo/updSemenIssued',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/beefCattleApi.js